export const GET_W2P_CONTENT_REQUEST = 'GET_W2P_CONTENT_REQUEST';
export const GET_W2P_CONTENT_SUCCESS = 'GET_W2P_CONTENT_SUCCESS';
export const GET_W2P_CONTENT_FAIL = 'GET_W2P_CONTENT_FAIL';

export const UPDATE_THUMBNAIL = 'UPDATE_THUMBNAIL';
export const UPDATE_THUMBNAIL_SUCCESS = 'UPDATE_THUMBNAIL_SUCCESS';
export const UPDATE_THUMBNAIL_FAIL = 'UPDATE_THUMBNAIL_FAIL';
